import AddNodeEdge from "./edges/AddNodeEdge"

export const NODE_W = 220
export const NODE_H = 80

export const FIT_VIEW_PADDING = 0.25

export const DROP_THRESHOLD = 50

export const LAYOUT_BRANCH_OFFSET = 140
export const LAYOUT_Y_STEP = 180

export const HANDLE_X_PCT: Record<string, Record<string, number>> = {
  trigger: { output: 0.5 },
  action: { output: 0.5 },
  condition: { "true-output": 0.25, "false-output": 0.75 }
}

export const TERMINAL_Y_OFFSET = NODE_H + 54

export const edgeTypes = {
  addNode: AddNodeEdge
}

export type TerminalTarget = { nodeId: string; handleId: string }
